import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/73abb31c-8496-4da3-ab97-b3008ddd1811";
export const REGISTER_URL = "https://a.ntrk2.com/9e63e416-02e9-4f99-80d1-463b03567b48";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bonanzaph.loadprkw2a.com/download?openExternalBrowser=1&id=j3ipz7ov7lr6qmk";

export * from "./codes";
export * from "./context";
